import * as serviceWorker from './serviceWorker';
require('./style/registridoce.scss');
require('./style/animate.css');
require('he/he.js');
require('whatwg-fetch');
// ************************************************************
//  The React Application
//
require('./scripts/registridoce-app.jsx');
//
// ************************************************************

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
